(function ($, Global) {
    var SignupNewsletterModalComponent = function () {
        // Déclaration class objet
    };

    SignupNewsletterModalComponent.prototype.initEvents = function () {
        this.subscribers();
        this.publishers();
    }

    SignupNewsletterModalComponent.prototype.publishers = function () {
        $(document).on('show.bs.modal', '#modalNewsletter', function () {
            if (!$(this).find('input[name=Origin]').exists()) return;
            $(this).find('input[name=Origin]').val("Modal")
        });
    }

    SignupNewsletterModalComponent.prototype.subscribers = function () {
        $.Topic('signup-newsletter-modal-show').subscribe(function (){
            if ($('#modalNewsletter').exists()) {
                return $('#modalNewsletter').modal('show')
            }

            $.Topic('loader-show').publish();
        });

        $.Topic('signup-newsletter-modal-hide').subscribe(function () {
            if ($('#modalNewsletter').exists()) {
                return $('#modalNewsletter').modal('hide')
            }
        });
    }

    Global.SignupNewsletterModalComponent = SignupNewsletterModalComponent;
}(jQuery, window));